// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"a068e735","404":"a445983e","498":"e76bee3e","733":"9131b94e","787":"cb01ce16"}[chunkId] + ".chunk.js";
};